import React, {Component} from "react";
import {Link} from "react-router";
import TopNav from "../../common/nav/TopNav";
import Footer from "../../common/Footer";
import PageBlock from "../../common/PageBlock";
import ActionConfigService from "../../service/ActionConfigService";

class ActionConfig extends Component {
    componentDidMount() {
        ActionConfigService.loadActionConfig();
    }

    render() {
        return (
            <div>
                <TopNav tab="actions"/>

                <PageBlock>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 m-b-md">
                                <h1 className="page-header">Actions</h1>
                                <h4 className="text-muted">Set up your builds.</h4>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-12">
                                <p>This section controls how your bot responds to your messages.
                                    You can add actions to trigger your jobs and any parameters they require.</p>

                                <div className="callout m-t">
                                    <div className="callout-content">
                                        <strong>Need some inspiration?</strong> Learn more about configuration
                                        and see our samples.
                                    </div>
                                    <div className="callout-secondary">
                                        <Link to="/docs/bot/actions" className="btn btn-sm btn-info">Learn more</Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-10 col-md-8 col-lg-8">

                                <div className="panel panel-info">
                                    <div className="panel-heading"><h3 className="panel-title">Configuration</h3></div>
                                    <div className="panel-body">

                                        <div className="form-group">
                                            <label className="sr-only" htmlFor="actionConfig">Action Configuration</label>
                                            <textarea id="actionConfig" name="actionConfig"
                                                      className="form-control" rows="12" required=""/>
                                        </div>

                                        <hr/>

                                        <h5>Already have a config file?</h5>
                                        <div className="row">
                                            <div className="col-xs-8">
                                                <p>Upload a valid YAML configuration file.</p>
                                                <input type="file" id="actionConfig-file" name="actionConfig-file"/>
                                            </div>
                                            <div className="col-xs-4 text-right">
                                                <button onClick={ActionConfigService.handleFileSelect}
                                                        id="actionConfig-upload" className="btn btn-default">Upload
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <button onClick={ActionConfigService.saveActionConfig} className="btn btn-primary btn-block">
                                                Save
                                            </button>
                                        </div>
                                        <div className="col-sm-6 m-t-sm-c-xs">
                                            <Link className="btn btn-default btn-block" to="/dashboard">Cancel</Link>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </PageBlock>

                <Footer />
            </div>
        );
    }
}

export default ActionConfig;



// WEBPACK FOOTER //
// ./src/modules/views/bot/Actions.js